import React, {useContext} from "react";
import Axis from "../Components/Axis";
import Button from "../Components/Button";
import {DataContext} from "../Context/DataContext";
import {VARIABLES} from "../Services/Constants/variables";

export default function SelectVariables() {
	let {setShowedScreen, requestVariables, setPageHeight} = useContext(DataContext);

	// Go to the next page
	const goToSuggestedMarkets = () => {
		const keys = Object.keys(requestVariables);
		let haveVariables = 0;

		// Checks if all axis have at least one variable
		for (let i = 0; i < keys.length; i++) {
			if (keys[i] === "logistica") haveVariables += 1;
			else {
				if (requestVariables[keys[i]].length === 0) {
					alert("Por favor, seleccione al menos una variable por cada eje.");
					return;
				} else haveVariables += 1;
			}
		}

		// If all axis have a variable, the following query is made
		if (haveVariables === keys.length) {
			setShowedScreen(2);
			setPageHeight(window.innerHeight);
			window.scrollTo(0, 0);
		}
	};

	return (
		<div className='page-content'>
			<div className='go-back-and-title without-go-back'>
				<h1 className='title'>SELECCIÓN DE VARIABLES</h1>
			</div>
			<div className='dividing-line'></div>
			<p className='paragraph first-p-select'>
				Para calcular los 3 mercados de destino más indicados para tu producto o servicio debes escoger las opciones más relevantes de acuerdo a los seis ejes de análisis (Demanda, Idioma,
				Estabilidad de mercados, eCommerce, y Acceso). Puedes escoger una o varias opciones por temática. Si quieres conocer más sobre cada variable, coloca tu cursor sobre el ícono de
				información al lado de estas.
			</p>
			<p className='paragraph'>
				Una vez tengas tus variables seleccionadas, realiza el cálculo con el botón al final de esta página para conocer los 3 mercados que ofrecen mejores oportunidades para tí.
			</p>
			<div className='dividing-line'></div>
			{VARIABLES.map((v) => (
				<>
					<Axis id={v.id} title={v.title} variables={v.variables} />
					<div className='dividing-line'></div>
				</>
			))}
			<Button content={"Calcular mercados destino"} type={"default"} size={"big"} action={goToSuggestedMarkets} />
		</div>
	);
}
